export default __webpack_public_path__ + "static/media/niseko1.c2b3f693.webp";